import { coerceBooleanProperty } from "@angular/cdk/coercion";
import {
  AfterContentInit,
  Component,
  ContentChildren,
  HostBinding,
  Input,
  QueryList,
  forwardRef
} from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";

import { BUTTON_GROUP } from "@lantern/app/common/forms/base/abstract-button-group";
import { AbstractButtonGroup } from "../base/abstract-button-group";
import { ButtonOptionComponent } from "./button.component";

@Component({
  selector: "ta-button-group",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ButtonGroupComponent),
      multi: true
    },
    {
      provide: BUTTON_GROUP,
      useExisting: ButtonGroupComponent
    }
  ],
  template: `
    <ng-content></ng-content>
  `
})
export class ButtonGroupComponent
  extends AbstractButtonGroup<ButtonOptionComponent>
  implements AfterContentInit {
  @ContentChildren(forwardRef(() => ButtonOptionComponent))
  childControls: QueryList<ButtonOptionComponent>;

  @HostBinding("class.uniform")
  @Input()
  get uniform(): boolean {
    return this._uniform;
  }
  set uniform(value: boolean) {
    this._uniform = coerceBooleanProperty(value);
  }
  private _uniform: boolean = false;

  @HostBinding("class.button-group")
  className = true;

  @HostBinding("class.touched")
  get touchedClassName(): boolean {
    return this.touched;
  }

  @HostBinding("class.button-group--disabled")
  get disabledClassName(): boolean {
    return this.disabled;
  }
}
